import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Alert } from '../models/alert-class';
import { CommercialClass, CommercialsAreaLayoutResumeClass } from '../models/commercial-class';
import {
  RoutesConfig,
  CommonDefaultsClass,
  SexTypesClass,
  MaritalStatusClass,
  GenreClass,
  ProfessionalsituationClass,
  CommonCAEClass,
  EmailsTemplateClass,
  CommonNIFTypeClass,
  CommonEntityTypeClass,
  CommonAutoBrokenGlassClass,
  CommonLiabilityClass,
  CommonAutoDeductible,
  CommonAutoPassengers,
  CommonAutoCarReplacement,
  CommonAutoCarMaintenance,
  CommonVesselsPersonalAccidentsClass,
  EmailClass,
  Steps,
  CommonAutoBrandClass,
  CommonAutoBrandModelClass,
  CommonAutoBrandModelVersionClass,
  CommonAutoFuelClass,
  CommonAutoVehicleSelectionClass,
  CommonAutoVehicleTypeClass,
  CommonAutoVehicleUsageClass,
  CommonKeepPriceAsNewClass,
  BreedsClass,
  BreedsTypeClass,
} from '../models/common-class';
import { CompaniesClass } from '../models/companies-class';
import { CustomerLayoutClass, CustomerClass, CustomerShipToAddressClass } from '../models/customer-class';
import {
  InsuranceClaimsCausesTypesClass,
  InsuranceClaimsStatusTypesClass,
  InsuranceclaimsClass,
} from '../models/insuranceclaims-class';
import { InsurancePolicyStatusTypesClass } from '../models/insurancesPolicy-class';
import { MessageCenterStatusClass } from '../models/messagecenter-class';
import { PaymentsTypesClass, PaymentsSplitClass } from '../models/payments-class';
import { ProductsClass, ProductsTypesClass } from '../models/products-class';
import { LoggedUserClass } from '../models/users-class';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { LoggingService } from './logging.service';
import { UsersService } from './users.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ValidateFieldMessage } from '../models/validatefield-class';
import {
  SafesimulationsClass,
  SafeSimulationsStatusTypes,
  ProductsProposalsCompareClass,
} from 'src/app/shared/models/safesimulations-class';

@Injectable({
  providedIn: 'root', // Isso garante que o serviço seja singleton e global.
})
export class GlobalService {
  private devModeChanged = new BehaviorSubject<boolean>(false);
  public toggleChatbot$ = new Subject<void>();
  public devTagsChanged$ = new BehaviorSubject<boolean>(false); // Novo subject para tags
  public contactsFormSubmitTrigger$ = new BehaviorSubject<boolean>(false);
  public loginFormSubmitTrigger$ = new BehaviorSubject<boolean>(false);
  public nifWarningAction$ = new BehaviorSubject<string>('');
  public validationChanged$ = new BehaviorSubject<void>(undefined);

  /** Flag to indicate if session restore is in progress */
  public isRestoringSession$ = new BehaviorSubject<boolean>(true);

  // Controle de layout e navegação customizada
  public HideNavigationButtons = false;
  public HideBackButton = false; // New flag to specifically hide the back button
  public purchaseCompleted = false; // Flag to hide buttons/stepper after purchase completion
  /** Token de activação gerado durante Guest Checkout — usado para redirect para /login/active */
  public guestActivationToken: string | null = null;
  public isInsideDialog = false; // 🛡️ GLOBAL: Flag to indicate if current view is inside a MatDialog

  // Custom Navigation (Centralizada)
  public CustomNavigationActive = false;
  public CustomNextLabel = 'Seguinte';
  public CustomNextDisabled = false;
  public CustomNextAction: () => void;
  public CustomBackAction: () => void;
  public CustomBackLabel: string = 'Voltar'; // 🛒 Label customizada para voltar na compra
  public CustomFinalizeLabel: string = 'Finalizar'; // 🛒 Label customizada para finalizar na compra
  public CustomFinalizeAction: () => void; // 🛒 Ação específica para o FINALIZAR
  /** Trigger para animar erro no questionário quando navegação falha */
  public triggerQuizError$ = new BehaviorSubject<void>(undefined);
  /** Emitido quando o conteúdo de um tab interno do quiz muda assincronamente
   *  (ex: validações do tomador, switch de estado NIF). Os questionários
   *  devem subscrever e chamar realignInkBar() para forçar o dynamicHeight
   *  a recalcular a altura correta do mat-tab-group.
   */
  public quizTabGroupHeightRefresh$ = new BehaviorSubject<void>(undefined);
  /** Evento emitido após login inline bem-sucedido - questionários devem escutar para recarregar dados */
  public loginSuccess$ = new BehaviorSubject<boolean>(false);
  public profilePhotoLoaded$ = new BehaviorSubject<boolean>(false);

  devModeChanged$ = this.devModeChanged.asObservable();

  isInsurance: boolean = true;
  notificationComponentTabIndex: number = 0;
  public PrintLayoutModeSafesimulation: boolean = false;
  public PrintLayoutModeinsuranceClaims: boolean = false;
  public insuranceclaimsClass: InsuranceclaimsClass;
  public safesimulationsClass: SafesimulationsClass = new SafesimulationsClass();

  public productsTypesSeleccionado: ProductsTypesClass;
  public awaitselectProdType: boolean;

  public validateFieldMessage: ValidateFieldMessage[] = [];

  public pagedList: ProductsClass[] = [];

  public IsWait: boolean;
  public showProgress: boolean;
  public ViewLoad: boolean;

  public selectedTab = 0;
  public maxTabIndex = 0; // Máximo índice permitido (atualizado por ProductstypesitemsComponent)
  public selectedTabLabel: string;
  public selectedTabQuiz = 0;
  public selectedTabPurchase = 0; // 🛒 Dedicated for Purchase Tab steps
  public selectedTabQuizTabs = 0;

  /** Stack de IDs de produtos/categorias para permitir navegação "Voltar" na árvore */
  public productNavigationStack: number[] = [];

  public selectedTabQuizTabsSteps: Steps[] = [];
  public selectedTabPurchaseSteps: any[] = []; // 🛒 Steps for Purchase Tab

  // 🛒 Dados universais do Resumo de Compra — populados por cada componente de compra
  public summaryProposalData: any = {};
  public summaryCustomerData: any = {};
  public summaryProductType: string = '';
  public summaryQuestionnaireData: any = null; // referência ao safesimulationsClass do contexto
  public isCollectingContactInfo = false; // Flag para mostrar "Seguinte" em vez de "Simular"
  public isContactFormValid = false; // Flag para validar formulário de contactos
  public contactFormCurrentState: string = 'contacts'; // Estado atual do formulário de contactos
  public isLoginFormValid = false; // Flag para validar formulário de login
  public selectedArea = '';

  /**
   * Define selectedTab com validação - garante que nunca excede maxTabIndex
   * Para uso por serviços externos (productsAux.service, etc)
   */
  public setSelectedTabSafe(value: number): void {
    // Se maxTabIndex ainda estiver a 0 (ex.: utilizador anónimo antes do primeiro ciclo de initVisibleTabs),
    // calcular limite seguro com base na configuração atual da simulação
    const fallbackMax =
      value > 0 && this.maxTabIndex < value
        ? (this.safesimulationsClass?.SkipQuiz ? 1 : 2) + (this.safesimulationsClass?.OpenpurchaseComponent ? 1 : 0)
        : this.maxTabIndex;
    const maxIndex = Math.max(this.maxTabIndex, fallbackMax);
    const safeValue = Math.max(0, Math.min(value, Math.max(0, maxIndex)));

    if (safeValue !== value && this.maxTabIndex > 0) {
      /*
      console.warn(
        `⚠️ GlobalService.setSelectedTabSafe: ajustado de ${value} para ${safeValue} (maxTabIndex: ${this.maxTabIndex})`,
      );
      */
    }

    this.selectedTab = safeValue;
  }

  /**
   * Atualiza com segurança o estado 'invalid' de um step.
   * Previne TypeError se os steps ainda não estiverem carregados ou forem indefinidos.
   */
  public setStepInvalid(stepIndex: number, invalid: boolean, context: 'quiz' | 'purchase' = 'quiz'): void {
    const steps = context === 'quiz' ? this.selectedTabQuizTabsSteps : this.selectedTabPurchaseSteps;
    if (steps && steps[stepIndex]) {
      const changed = steps[stepIndex].invalid !== invalid;
      //   if (changed) {
      //     console.log(`🔔 GlobalService: Validation changed for ${context} step ${stepIndex}. Invalid: ${invalid}`);
      //   }
      steps[stepIndex].invalid = invalid;
      if (changed) {
        this.validationChanged$.next();
      }
    } else {
      console.warn(
        `⚠️ GlobalService: Attempted to set invalid=${invalid} for non-existent ${context} step ${stepIndex}`,
      );
    }
  }

  public tabGroup: string[];

  public nivelProduto: number;
  public OpenComponent: string;
  public OpenComponentCotacoes: string;
  public OpenInsuranceClaimsComponent: string;

  public idProductsTypesOrder: number;

  public ValueFocus: boolean;
  public msgIndisponivel: boolean;
  public nifValid: boolean;

  public commonAutoVehicleTypeClass: CommonAutoVehicleTypeClass[] = [];
  public commonAutoVehicleUsageClass: CommonAutoVehicleUsageClass[] = [];
  public commonAutoVehicleSelectionClass: CommonAutoVehicleSelectionClass[] = [];
  public commonAutoFuelClass: CommonAutoFuelClass[] = [];
  public commonAutoBrandClass: CommonAutoBrandClass[] = [];
  public commonAutoBrandModelClass: CommonAutoBrandModelClass[] = [];
  public commonAutoBrandModelVersionClass: CommonAutoBrandModelVersionClass[] = [];
  public commonKeepPriceAsNewClass: CommonKeepPriceAsNewClass[] = [];
  public commonLiability: CommonLiabilityClass[] = [];
  public commonAutoBrokenGlassClass: CommonAutoBrokenGlassClass[] = [];

  public breedsTypeClass: BreedsTypeClass[];
  public breedsClass: BreedsClass[];

  public safeSimulationsStatusTypes: SafeSimulationsStatusTypes[] = [];
  // public tempProductsProposalsClass: ProductsProposalsClass[];
  public tempcustomerShipToAddressClass: CustomerShipToAddressClass;

  public productsProposalsCompareClass: ProductsProposalsCompareClass;

  public showPedidoCotacao: boolean = false;
  public showFilters: boolean = true;

  public isMobileDevice: boolean = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;
  public isLocalhost: boolean =
    typeof window !== 'undefined'
      ? window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      : false;
  public isMobileDeviceSemelhante: boolean;
  public options: MatDrawer;
  private _loadingSpinner: boolean = false;
  public loadingSpinner$ = new BehaviorSubject<boolean>(false);
  get loadingSpinner(): boolean {
    return this._loadingSpinner;
  }
  set loadingSpinner(value: boolean) {
    this._loadingSpinner = value;
    this.loadingSpinner$.next(value);
  }

  public appLocalVersion: string;
  public SelectedTabauthenticate: number;
  private _loadingMessage: string = 'A carregar dados...';
  public loadingMessage$ = new BehaviorSubject<string>('A carregar dados...');
  get loadingMessage(): string {
    return this._loadingMessage;
  }
  set loadingMessage(value: string) {
    this._loadingMessage = value;
    this.loadingMessage$.next(value);
  }
  public FullMenu: boolean;

  public logotipoCantoSuperiorEsquerdo = '/assets/logotipos/logotexto.png';

  public SendAdminAccessAlert: boolean;
  public activeRequests: number = 0;

  public RequestProgress: boolean;
  public customerLayoutClass: CustomerLayoutClass[];
  public EnableDevelopermode: boolean;
  public ShowDevTags: boolean = false; // Nova flag para controlar tags visuais
  public showInfoProductsContent: boolean;
  public ShowHomeCarousel: boolean = true;
  /** Flag para esconder o Smiley quando o chatbot está aberto */
  public isChatbotOpen: boolean = false;

  public filterValueGlobal: string;
  public filtercompanieValueGlobal: string;
  public routesConfigGlobal: RoutesConfig;
  private _loggedUserClass: LoggedUserClass = new LoggedUserClass();
  public get loggedUserClass(): LoggedUserClass {
    if (!this._loggedUserClass) {
      this._loggedUserClass = new LoggedUserClass();
    }
    if (!this._loggedUserClass.customerClass) {
      this._loggedUserClass.customerClass = new CustomerClass();
    }
    return this._loggedUserClass;
  }
  public set loggedUserClass(val: LoggedUserClass | null | undefined) {
    this._loggedUserClass = val || new LoggedUserClass();
    if (!this._loggedUserClass.customerClass) {
      this._loggedUserClass.customerClass = new CustomerClass();
    }
  }
  public commonDefaultsClass: CommonDefaultsClass;
  public alertGeralMenuUser: Alert = new Alert();

  //  COMMON
  public sexTypesClass: SexTypesClass[];
  public maritalStatusClass: MaritalStatusClass[];
  public genreClass: GenreClass[];
  public professionalsituationClass: ProfessionalsituationClass[];
  public commonCAEClass: CommonCAEClass[];

  public companies: CompaniesClass[];
  public productsClass: ProductsClass[];
  public productsTypesClass: ProductsTypesClass[];
  public productsTypesItemsClass: ProductsTypesClass[];

  public paymentsTypesClass: PaymentsTypesClass[];

  public SelectproductsTypes: ProductsTypesClass[];
  public Selectproduct: ProductsClass;

  public SelectidProduct: number;
  public SelectProductName: string;
  public SelectBackgroundColor: string;
  public SelectTextColor: string;

  public CustomerClassAll: CustomerClass[];
  public insurancePolicyStatusTypesClass: InsurancePolicyStatusTypesClass[];
  public insuranceClaimsCausesTypesClass: InsuranceClaimsCausesTypesClass[];
  public InsuranceClaimsStatusTypesClass: InsuranceClaimsStatusTypesClass[];

  public CommercialClassAll: CommercialClass[];
  public emailsTemplateClass: EmailsTemplateClass[];

  // InsurancePolicy

  public paymentsSplitClass: PaymentsSplitClass[];
  public commonNIFTypeClass: CommonNIFTypeClass[];

  public alertProducts: Alert[] = [];
  // public alertUser: Alert[] = [];

  public alertClientAreaInsurances: Alert[] = [];
  public alertClientAreaSafeSimulations: Alert[] = [];
  public alertClientAreaInsurancesClaims: Alert[] = [];
  public alertClientAreaCompaniesContacts: Alert[] = [];
  public alertClientAreaCompaigns: Alert[] = [];

  public commercialsAreaLayoutResumeClassTop: CommercialsAreaLayoutResumeClass[];
  public commercialsAreaLayoutResumeClass: CommercialsAreaLayoutResumeClass[];
  public commonEntityTypeClass: CommonEntityTypeClass[];

  // Auto

  public commonAutoDeductible: CommonAutoDeductible[];
  public commonAutoPassengers: CommonAutoPassengers[];
  public commonAutoCarReplacement: CommonAutoCarReplacement[];
  public commonAutoCarMaintenance: CommonAutoCarMaintenance[];
  public commonVesselsPersonalAccidentsClass: CommonVesselsPersonalAccidentsClass[];
  public isNIFEmpresa: boolean = false;

  // MessageCenter

  public messageCenterStatusClass: MessageCenterStatusClass[];

  private _isChangeNIFInProgress: boolean = false;
  get isChangeNIFInProgress(): boolean {
    return this._isChangeNIFInProgress;
  }
  set isChangeNIFInProgress(value: boolean) {
    setTimeout(() => {
      this._isChangeNIFInProgress = value;
    });
  }

  // ========== HELPERS PARA CALCULAR ÍNDICES DE TABS DINÂMICOS ========== //

  /**
   * Verifica se o tab de Produto está visível
   * Tab 0: Produto - visível quando:
   * - nivelProduto === -1 (nenhum sub-produto selecionado, mostra lista raiz)
   * - nivelProduto >= 0 (a navegar na árvore de sub-produtos, mostra filhos)
   * Escondido quando OpenComponent está definido (produto folha selecionado,
   * a navegar para quiz/propostas)
   */
  get showProductTab(): boolean {
    return !this.OpenComponent;
  }

  // showContactsTab REMOVED - Issue #58

  /**
   * Verifica se o tab de Questionário está visível
   * Tab 2: Questionário - visível se tiver quiz E não estiver a recolher contactos
   */
  get showQuizTab(): boolean {
    const hasQuiz = !this.safesimulationsClass?.SkipQuiz;
    return hasQuiz; // Issue #58: Simplified - no isCollecting check
  }

  /**
   * Verifica se o tab de Proposta está visível
   * Tab 3: Proposta - escondido enquanto estiver a recolher contactos
   */
  get showProposalTab(): boolean {
    return true; // Issue #58: Always visible
  }

  /**
   * Verifica se o tab de Compra está visível
   * Tab 4: Compra - depende se existe OpenpurchaseComponent
   */
  get showPurchaseTab(): boolean {
    return !!this.safesimulationsClass?.OpenpurchaseComponent;
  }

  // getContactsTabIndex() REMOVED - Issue #58

  /**
   * Retorna o índice dinâmico do tab de questionário
   */
  getQuizTabIndex(): number {
    if (!this.showQuizTab) return -1;
    let index = 0;
    if (this.showProductTab) index++;
    // showContactsTab removed - Issue #58
    return index;
  }

  /**
   * Retorna o índice dinâmico do tab de proposta
   */
  getProposalTabIndex(): number {
    if (!this.showProposalTab) return -1;
    let index = 0;
    if (this.showProductTab) index++;
    // showContactsTab removed - Issue #58
    if (this.showQuizTab) index++;
    return index;
  }

  /**
   * Retorna o índice dinâmico do tab de compra
   */
  getPurchaseTabIndex(): number {
    if (!this.showPurchaseTab) return -1;
    let index = 0;
    if (this.showProductTab) index++;
    // showContactsTab removed - Issue #58
    if (this.showQuizTab) index++;
    if (this.showProposalTab) index++;
    return index;
  }

  // ==========================================================================

  constructor(
    private commonService: CommonService,
    private loggingService: LoggingService,
    private usersService: UsersService,
  ) {
    this.commonAutoBrokenGlassClass = [];
    this.commonLiability = [];
    this.commonAutoDeductible = [];
    this.commonAutoPassengers = [];
    this.commonAutoCarReplacement = [];
    this.commonAutoCarMaintenance = [];
    this.routesConfigGlobal = new RoutesConfig();
    this.routesConfigGlobal.HideHome = false;
    this.routesConfigGlobal.HideSimulations = true;
    this.routesConfigGlobal.HidePolicies = true;
    this.routesConfigGlobal.HideInsuranceclaims = true;
    this.routesConfigGlobal.HideContacts = false;
    this.routesConfigGlobal.HideSitemanagement = true;
    this.routesConfigGlobal.HideCommercialarea = true;
    this.routesConfigGlobal.HideIntermediaryArea = true;
    this.routesConfigGlobal.HideClientarea = true;
    this.activeRequests = 0;

    // Listener para atualizar isMobileDevice quando a janela é redimensionada
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.isMobileDevice = window.innerWidth <= 768;
      });
    }
  }

  AtiveDevMode() {
    if (!this.loggedUserClass?.Admin) {
      console.warn('⚠️ Acesso Negado: Apenas administradores podem ativar o modo de gestão.');
      return;
    }

    // Se estivermos a tentar ATIVAR, confirmamos na base de dados
    if (!this.EnableDevelopermode) {
      this.usersService.GetUserId(this.loggedUserClass.idUser).subscribe({
        next: userFromDB => {
          //   console.log(userFromDB);
          if (userFromDB && userFromDB[0].Admin) {
            // Utilizador confiável, procedemos
            this.loggedUserClass.Admin = true;
            this.toggleDevModeInternal();
          } else {
            // Acesso revogado ou erro - desativamos tudo
            console.error('🛑 Acesso de administrador revogado ou inválido na base de dados.');
            this.loggedUserClass.Admin = false;
            this.EnableDevelopermode = false;
            this.notifyDevModeChanged();
          }
        },
        error: err => {
          console.error('❌ Erro ao verificar permissões de admin:', err);
        },
      });
    } else {
      // Se estivermos a DESATIVAR, podemos fazê-lo localmente de imediato
      this.toggleDevModeInternal();
    }
  }

  private toggleDevModeInternal() {
    this.EnableDevelopermode = !this.EnableDevelopermode;

    // 🔍 Ativar/Desativar logs dinamicamente em produção baseado em permissões de admin
    if (environment.production) {
      if (this.EnableDevelopermode && this.loggedUserClass?.Admin) {
        this.loggingService.enableLogs();
      } else {
        this.loggingService.disableLogs();
      }
    }

    if (this.EnableDevelopermode && !this.SendAdminAccessAlert && environment.production) {
      if (!this.loggedUserClass?.customerClass) {
        // console.warn('AtiveDevMode: loggedUserClass output null, skipping alert.');
        this.notifyDevModeChanged();
        return;
      }
      // console.log('A enviar alerta do modo Administrador');

      const now = new Date().toLocaleString('pt-PT', { timeZone: 'Europe/Lisbon' });
      const userName = this.loggedUserClass.customerClass.Name || 'Utilizador';
      const userNIF = this.loggedUserClass.customerClass.NIF || '';
      const userEmail = this.loggedUserClass.customerClass.Email || '';

      let emailClass: EmailClass;
      emailClass = new EmailClass();
      emailClass.subject = '🔐 Alerta de Segurança - Modo Administrador Ativado';

      emailClass.html = `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; background: #f5f5f5; padding: 20px;">
          <!-- Header com logo -->
          <div style="background: linear-gradient(135deg, #1C1463 0%, #2d1f8a 100%); padding: 25px; border-radius: 12px 12px 0 0; text-align: center;">
            <img src="https://segurosvirtual.pt/assets/logotipos/logoSVbrancoSemFundo.png" alt="Seguros Virtual" style="max-width: 200px; height: auto;">
          </div>

          <!-- Alerta -->
          <div style="background: #ff9800; color: white; padding: 15px 20px; display: flex; align-items: center;">
            <span style="font-size: 28px; margin-right: 12px;">⚠️</span>
            <div>
              <strong style="font-size: 16px;">Alerta de Segurança</strong><br>
              <span style="font-size: 13px;">Modo Administrador Ativado</span>
            </div>
          </div>

          <!-- Conteúdo -->
          <div style="background: white; padding: 30px; border-left: 1px solid #ddd; border-right: 1px solid #ddd;">
            <p style="margin: 0 0 20px; color: #333;">Olá <strong>${userName}</strong>,</p>

            <p style="color: #555; line-height: 1.6;">
              Detetámos que o <strong>modo administrador</strong> foi ativado na sua conta.
              Se foi você que efetuou esta ação, pode ignorar este email.
            </p>

            <div style="background: #f8f9fa; border-left: 4px solid #1C1463; padding: 15px; margin: 25px 0; border-radius: 0 8px 8px 0;">
              <h3 style="margin: 0 0 15px; color: #1C1463; font-size: 14px;">📋 Detalhes do Acesso</h3>
              <table style="width: 100%; font-size: 13px; color: #555;">
                <tr>
                  <td style="padding: 6px 0; width: 120px;"><strong>Data/Hora:</strong></td>
                  <td style="padding: 6px 0;">${now}</td>
                </tr>
                <tr>
                  <td style="padding: 6px 0;"><strong>Utilizador:</strong></td>
                  <td style="padding: 6px 0;">${userName} (NIF: ${userNIF})</td>
                </tr>
                <tr>
                  <td style="padding: 6px 0;"><strong>Endereço IP:</strong></td>
                  <td style="padding: 6px 0;">${this.loggedUserClass.query || 'N/A'}</td>
                </tr>
                <tr>
                  <td style="padding: 6px 0;"><strong>Localização:</strong></td>
                  <td style="padding: 6px 0;">${this.loggedUserClass.city || 'N/A'}, ${this.loggedUserClass.country || 'N/A'}</td>
                </tr>
                <tr>
                  <td style="padding: 6px 0;"><strong>ISP:</strong></td>
                  <td style="padding: 6px 0;">${this.loggedUserClass.isp || 'N/A'}</td>
                </tr>
              </table>
            </div>

            <div style="background: #fff3e0; border: 1px solid #ff9800; padding: 15px; border-radius: 8px; margin: 25px 0;">
              <p style="margin: 0; color: #e65100; font-size: 13px;">
                <strong>⚠️ Não reconhece este acesso?</strong><br>
                Recomendamos que altere a sua password imediatamente.
              </p>
            </div>

            <p style="text-align: center; margin: 25px 0;">
              <a href="https://segurosvirtual.pt/login/changepassword"
                 style="background: #1C1463; color: white; padding: 14px 30px;
                        text-decoration: none; border-radius: 8px; display: inline-block;
                        font-weight: bold; box-shadow: 0 4px 12px rgba(28, 20, 99, 0.3);">
                Alterar Password
              </a>
            </p>
          </div>

          <!-- Footer -->
          <div style="background: #1C1463; padding: 20px; border-radius: 0 0 12px 12px; text-align: center;">
            <p style="color: rgba(255,255,255,0.8); font-size: 11px; margin: 0 0 10px;">
              Este é um email automático de segurança. Não responda a este email.
            </p>
            <p style="color: rgba(255,255,255,0.6); font-size: 10px; margin: 0;">
              © ${new Date().getFullYear()} Seguros Virtual - Mediação de Seguros<br>
              Todos os direitos reservados
            </p>
          </div>
        </div>
      `;

      emailClass.text = emailClass.html;
      emailClass.to = userEmail;
      emailClass.cc = '';
      emailClass.bcc = 'joao.vilar@segurosvirtual.pt';
      emailClass.NIF = userNIF;

      this.commonService.SendEmail(emailClass).subscribe({
        error: error => {
          this.SendAdminAccessAlert = true;
          console.log(error);
        },
        complete: () => {
          this.SendAdminAccessAlert = true;
        },
      });
    }

    this.notifyDevModeChanged();
  }

  notifyDevModeChanged() {
    this.devModeChanged.next(true);
  }

  toggleDevTags() {
    this.ShowDevTags = !this.ShowDevTags;
    this.devTagsChanged$.next(this.ShowDevTags);
  }
}
